__turbopack_context__.v({
  "confirmButton": "tour-confirm-skip-modal-module-scss-module__PYgBQa__confirmButton",
  "confirmModalButtons": "tour-confirm-skip-modal-module-scss-module__PYgBQa__confirmModalButtons",
  "content": "tour-confirm-skip-modal-module-scss-module__PYgBQa__content",
  "skipButton": "tour-confirm-skip-modal-module-scss-module__PYgBQa__skipButton",
  "title": "tour-confirm-skip-modal-module-scss-module__PYgBQa__title",
});
